export default __webpack_public_path__ + "static/media/news2img4.38670440.png";